import React from "react";

export const ArrowDown = (): JSX.Element => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12.3137 -0.000231911V22.6272" stroke="currentColor" strokeLinejoin="round" />
      <path d="M23.6274 11.3135L12.3137 22.6272L1.00002 11.3135" stroke="currentColor" strokeLinejoin="round" />
    </svg>
  );
};
